import React from "react";
import styled from "styled-components";
import SecondaryButton from "../../ui-library/Buttons/SecondaryButton/SecondaryButton";
import { profiles } from "../../../modules/constants";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const PageTitleWrapper = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .user-info {
    margin-left: 2rem;
    display: flex;
    flex-direction: column;

    .first-line {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      div {
        display: flex;
        flex-direction: row;
      }
    }

    .second-line span {
      font-size: 14px;
    }

    button {
      font-weight: 600;
      height: 30px;
      font-size: 14px;
      color: ${(props) => props?.theme?.darkPurple} !important;
      border: 0px;
      margin-top: 3px;
      margin-left: 5px;
      padding-left: 10px;
      padding-right: 10px;
      background: white;
      cursor: pointer;

      &:hover,
      &:focus {
        opacity: 0.8;
        background: white;
      }
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    & > div {
      justify-content: space-between;
    }
    & > .study-info {
      margin-bottom: 1rem;
    }
    & > .user-info {
      margin-left: 0;

      .user-id {
        margin-right: auto;
      }

      justify-content: space-between;
    }
  }
`;

const Title = styled.h3`
  margin-right: 10px;
  @media (max-width: 460px) {
    font-size: 1.5rem;
  }
`;

const Subtitle = styled.p`
  line-height: 1.2;
  font-size: 1.75rem;
  font-weight: 600;
  color: ${(props) => props?.theme?.c7Silver};
  @media (max-width: 460px) {
    font-size: 0.9rem;
    display: flex;
    align-items: center;
  }
`;

const RoleName = styled.div`
  font-weight: 400;
  border: 2px solid transparent;
  border-radius: 0.4rem;
  color: ${(props) => props?.theme?.white};
  background-color: ${(props) => props?.theme?.darkPurple};
  border-color: ${(props) => props?.theme?.darkPurple};
  font-size: 14px;
  padding: 0px 2px;
  height: 26px;
  margin-top: 6px;
  text-align: center;
  margin-right: 10px;
`;

const IdWrapper = styled.span`
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 30px;
  color: ${(props) => props?.theme?.nero};
  margin-top: 3px;
  padding-right: 10px;

  @media (max-width: 460px) {
    font-size: 18px;
  }
`;

const PageTitle = ({
  title,
  subtitle,
  roleName,
  id,
  setShowContactInfoModal,
  showContactInfo,
  participantUgnxId,
  site,
}) => {
  const { t } = useTranslation();

  return (
    <PageTitleWrapper data-testid="page-title-wrapper">
      <div className="study-info">
        <Title>
          {title}
          <div className="card-header-separator-lg"></div>
        </Title>
        <Subtitle>{subtitle}</Subtitle>
      </div>
      <div className="user-info">
        <div className="first-line">
          {
            //Check if id which is fetched remotely already exists, if doesn't display loading.
            id ? (
              <>
                <IdWrapper className="user-id">{id}</IdWrapper>
                <div>
                  {roleName && (
                    <RoleName className="role">
                      {roleName === profiles.participant
                        ? t(`appText.participant`)
                        : roleName}
                    </RoleName>
                  )}
                  {site && <RoleName className="role">{site}</RoleName>}

                  {showContactInfo && (
                    <SecondaryButton
                      data-testid="user-config-btn"
                      className="user-config"
                      size={"sm"}
                      onClick={() => setShowContactInfoModal(true)}
                    >
                      <i className="fas fa-user-cog" />
                    </SecondaryButton>
                  )}
                </div>
              </>
            ) : (
              <Spinner animation="border" />
            )
          }
        </div>
        {roleName !== profiles.participant && participantUgnxId && (
          <div className="second-line">
            <span>Viewing participant {participantUgnxId}</span>
          </div>
        )}
      </div>
    </PageTitleWrapper>
  );
};

export default PageTitle;
